module.exports = __webpack_public_path__ + "static/ww-logo-6e2a19f6c1e1f68de79ed22db0c59f46.jpg";